import { LIST_ITEM_DEFINITIONS, PARAGRAPH_DEFINITIONS } from '../definitions';
import { isList } from '../helpers';
import { linkifyText } from './linkify-text';
export const linkifyDocument = (document) => document === null || document === void 0 ? void 0 : document.map((node) => {
    var _a, _b;
    if (node.type === PARAGRAPH_DEFINITIONS.type) {
        node.children = (_a = node.children) === null || _a === void 0 ? void 0 : _a.map((child) => linkifyText(child)).flat(1);
    }
    if (isList(node.type))
        node.children = (_b = node.children) === null || _b === void 0 ? void 0 : _b.map((child) => {
            var _a;
            if (child.type === LIST_ITEM_DEFINITIONS.type)
                child.children = (_a = child.children) === null || _a === void 0 ? void 0 : _a.map((grandChildren) => linkifyText(grandChildren)).flat(1);
            return child;
        });
    return node;
});
//# sourceMappingURL=linkify-document.js.map